import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const ConfirmBlock = styled(Box)(() => ({
  display: 'flex',
  gap: '10px',
  marginBottom: '11px',
}));
